"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _image = require("./image.styles");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _assertion = require("../utils/assertion");

var _jsxRuntime = require("react/jsx-runtime");

const defaultProps = {
  opacity: 0.5,
  className: ''
};

const ImageSkeleton = /*#__PURE__*/_react.default.memo(({
  opacity,
  css,
  className,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_image.StyledImageSkeleton, {
    css: {
      opacity,
      ...css
    },
    className: (0, _clsx.default)('nextui-image-skeleton', className),
    ...props
  });
});

if (_assertion.__DEV__) {
  ImageSkeleton.displayName = 'NextUI - ImageSkeleton';
}

ImageSkeleton.toString = () => '.nextui-image-skeleton';

var _default = (0, _withDefaults.default)(ImageSkeleton, defaultProps);

exports.default = _default;
module.exports = exports.default;